/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_translate_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Does it translate RNA?`)
};

const es_translate_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Traduce ARN?`)
};

const de_translate_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Übersetzt es RNA?`)
};

const nl_translate_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vertaalt het RNA?`)
};

const fr_translate_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Traduit-il l'ARN ?`)
};

const it_translate_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Traduce l'RNA?`)
};

const pt_br2_translate_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ela traduz RNA?`)
};

const pt_translate_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Traduz ARN?`)
};

const ja_translate_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`RNAも翻訳できますか？`)
};

const zh_translate_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`可以翻译 RNA 吗？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const translate_faq_q4 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.translate_faq_q4(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("translate_faq_q4", locale)
	if (locale === "en") return en_translate_faq_q4(inputs)
	if (locale === "es") return es_translate_faq_q4(inputs)
	if (locale === "de") return de_translate_faq_q4(inputs)
	if (locale === "nl") return nl_translate_faq_q4(inputs)
	if (locale === "fr") return fr_translate_faq_q4(inputs)
	if (locale === "it") return it_translate_faq_q4(inputs)
	if (locale === "pt-BR") return pt_br2_translate_faq_q4(inputs)
	if (locale === "pt") return pt_translate_faq_q4(inputs)
	if (locale === "ja") return ja_translate_faq_q4(inputs)
	return zh_translate_faq_q4(inputs)
};